import { useState } from "react";
function l(e) {
  let [t] = useState(e);
  return t;
}
export {
  l as useDefaultValue
};
